import { useTranslations, useLocale } from "next-intl";
import { useLocalizedField } from "@/hooks/useLocalizedField";

export default function MaisonCard({ item }: { item: any }) {
  
  const t = useTranslations('guestHouses');
  const locale = useLocale();
  const isRTL = locale === 'ar';
  const { getLocalizedField } = useLocalizedField();
  
  if (!item) return (
    <div className="animate-pulse">
      <div className="h-96 bg-gray-300 rounded-2xl"></div>
    </div>
  ); 
  return (
    <a href={`/guest-houses/${item.slug}`} className="group cursor-pointer" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="relative h-96 rounded-2xl overflow-hidden">
        <img
          src={item.images?.[2]} // fallback
          alt={getLocalizedField(item, 'name') ?? t('defaultAlt')}
          className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
        {item.badge !== false && (
          <div className={`absolute top-4 ${isRTL ? 'left-4' : 'right-4'} bg-primary rounded-full p-2`}>
            <div className="w-2 h-2 bg-white rounded-full" />
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <h3 className="text-2xl font-bold mb-2 text-background">{getLocalizedField(item, 'name')}</h3>
        </div>
      </div>
    </a>
  );
}
